import { Filter } from '../../Enum/Filters';
import InterestUri from '../../Enum/InterestUri';
import { Sort } from '../../Interface/Table/Sort';
import { Period } from '../../Interface/Interest/Period';

export enum FilterType {
    sortChanged = 'sortChanged',
    filterHasChanged = 'filterHasChanged',
    filterIsFinishedLoading = 'filterIsFinishedLoading',
    filterIsSubmitted = 'filterIsSubmitted',
    filterResetRequest = 'filterResetRequest',
    togglePropertyCategory = 'togglePropertyCategory',
}

export interface SortingChangedAction {
    type: FilterType.sortChanged;
    section: InterestUri;
    value: Sort;
}

export interface FilterChangedAction {
    type: FilterType.filterHasChanged;
    name: Filter;
    value: number | string | number[] | string[] | Period[];
}

export interface FilterFinishedLoadingAction {
    type: FilterType.filterIsFinishedLoading;
}

export interface FilterSubmittedAction {
    type: FilterType.filterIsSubmitted;
}

export interface FilterResetRequestedAction {
    type: FilterType.filterResetRequest;
}

export interface TogglePropertyCategoryAction {
    type: FilterType.togglePropertyCategory;
    name: string;
}

export const sortingChanged = (section: InterestUri, value: Sort): SortingChangedAction => ({
    type: FilterType.sortChanged,
    section,
    value,
});

export const filterChanged = (
    name: Filter,
    value: number | string | number[] | string[] | Period[]
): FilterChangedAction => ({
    type: FilterType.filterHasChanged,
    name,
    value,
});

export const filterFinishedLoading = (): FilterFinishedLoadingAction => ({
    type: FilterType.filterIsFinishedLoading,
});

export const filterSubmitted = (): FilterSubmittedAction => ({
    type: FilterType.filterIsSubmitted,
});

export const filterResetRequested = (): FilterResetRequestedAction => ({
    type: FilterType.filterResetRequest,
});

export const toggledPropertyCategory = (name: string): TogglePropertyCategoryAction => ({
    type: FilterType.togglePropertyCategory,
    name
});

export type FilterActionTypes =
    | SortingChangedAction
    | FilterChangedAction
    | FilterFinishedLoadingAction
    | FilterSubmittedAction
    | FilterResetRequestedAction
    | TogglePropertyCategoryAction;
